/*导览讲解-子路由*/
export default [
  {
    path: "/tour/audio",
    name: "tour_audio",
    component: resolve =>
      require(["@/components/tour/audio/list.vue"], resolve),
    meta: {
      title: "语音导览",
      needLogin: false
    }
  },
  {
    path: "/qrcodescan/index",
    name: "qrcodescan",
    component: resolve =>
      require(["@/components/tour/qrcodescan/index.vue"], resolve),
    meta: {
      title: "二维码扫描",
      needLogin: false
    }
  },
  {
    path: "/map",
    name: "qrcodescan",
    component: resolve => require(["@/components/tour/map.vue"], resolve),
    meta: {
      title: "交通信息",
      needLogin: false
    }
  },
  // {
  //   path: "/media/index",
  //   name: "media",
  //   component: resolve =>
  //     require(["@/components/tour/media/index.vue"], resolve),
  //   meta: {
  //     title: "多媒体展示"
  //   }
  // },
  // {
  //   path: "/print/index",
  //   name: "print",
  //   component: resolve =>
  //     require(["@/components/tour/print/index.vue"], resolve),
  //   meta: {
  //     title: "书签打印"
  //   }
  // },
  // {
  //   path: "/product/index",
  //   name: "product",
  //   redirect: "/product/list",
  //   component: resolve =>
  //     require(["@/components/tour/product/index.vue"], resolve),
  //   meta: {
  //     title: "文创商城"
  //   },
  //   children: [
  //     {
  //       path: "/product/list",
  //       name: "product",
  //       component: resolve =>
  //         require(["@/components/tour/product/list.vue"], resolve),
  //       meta: {
  //         title: "文创商城-列表",
  //         needLogin: true
  //       }
  //     },
  //     {
  //       path: "/product/detail/:id",
  //       name: "product",
  //       component: resolve =>
  //         require(["@/components/tour/product/detail.vue"], resolve),
  //       meta: {
  //         title: "文创商城-详情",
  //         needLogin: true
  //       }
  //     }
  //   ]
  //}
];



// WEBPACK FOOTER //
// ./src/router/tour/index.js